export default __webpack_public_path__ + "static/media/durvis-7-min.4cb28bee.jpg";